import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
// TODO: Nesse primeiro momento será removido o suporte para troca de idiomas
// import LanguageDetector from 'i18next-browser-languagedetector'

i18n
  .use(Backend)
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'pt',
    fallbackLng: 'en',
    supportedLngs: ['en', 'pt'],
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
